import { render, staticRenderFns } from "./bar-chart-widget-form.vue?vue&type=template&id=6e2b34d4&"
import script from "./bar-chart-widget-form.vue?vue&type=script&lang=js&"
export * from "./bar-chart-widget-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports